export const COMPONENT_ID = 'rapidboard_settings_columns';
export const APP_IDENTIFIER = 'board-settings-columns';
export const APP_TEAM_NAME = 'a4t-pandora';
export const BOARD_SETTINGS_COLUMNS_UFO_NAME = 'board-settings.columns';
